import { Information } from 'assets/icons';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';

const Saisonnier = () => {
  const { dataCreateMission, setDataCreateMission } = UseContext();
  const [validMotif, setValidMotif] = useState(false);
  const [message, setMessage] = useState(() => {
    if (dataCreateMission?.motif?.type === '5') {
      return { type: '5', message: dataCreateMission.motif.message || '' };
    }
    return { type: '5', message: '' };
  });
  const [lengthMessage, setLengthMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [validMessage, setValidMessage] = useState(false);
  const { toggle } = useModal();
  const verif = message.message.length;

  useEffect(() => {
    if (verif <= 8) {
      setErrorMessage(true);
      setLengthMessage(false);
    } else {
      setErrorMessage(false);
      setLengthMessage(true);
    }
    setValidMotif(message.message.length > 0);
  }, [message, verif]);

  const handleMessage = (e) => {
    setMessage((prev) => ({ ...prev, message: e.target.value }));
  };

  const handleSubmit = () => {
    if (lengthMessage) {
      setDataCreateMission((prevData) => ({
        ...prevData,
        motif: message,
      }));
      toggle();
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Emploi à caractère saisonnier
      </Modalheader>
      <ModalBody>
        <form className="flex flex-col w-full gap-4 mt-4">
          <div className="flex flex-col">
            <label htmlFor="message">Votre Description</label>
            <textarea
              name="message"
              id="message"
              cols="30"
              rows="5"
              className="border border-gray-300 rounded-md"
              required
              maxLength={250}
              minLength={3}
              wrap="true"
              value={message.message}
              onChange={handleMessage}
            />
          </div>
          <span className="text-gray-400 nbLength">250 caractères </span>
          {errorMessage && (
            <p className="text-yellow-400 flex items-center gap-4">
              <Information wh={16} color={'#FFA43D'} />
              Veuillez faire un message de plus de 10 caractères
            </p>
          )}
        </form>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Annuler
        </Button>
        <Button size={'LG'} onClick={handleSubmit} disabled={!lengthMessage}>
          Confirmer
        </Button>
      </ModalFooter>
    </>
  );
};

export default Saisonnier;
